<template>
    <b-container fluid>
        <b-row class="school-container-layout mb-5" id="support">
            <b-col cols="12" class="support-content">
                <p class="support-text-content">“Necesitas ayuda o deseas contactarte, dejanos un mensaje”</p>
            </b-col>
            <b-col cols="12" class="mt-5">
                <b-row align-h="center">
                    <b-col cols="12" lg="6" class="mt-5 support-pdf-img">
                        <img :src="srcImagen('logo-soporte.svg')" alt="">
                    </b-col>
                    <b-col cols="12" lg="6" class="mt-5 support-form">
                        <b-form @submit.stop.prevent="onSubmit">
                            <b-form-group id="form-support" style="">
                                <b-form-textarea
                                        id="input-2"
                                        v-model="$v.form.mensaje.$model"
                                        rows="10"
                                        max-rows="10"
                                        placeholder="Escriba aqui"
                                        size="lg"
                                        aria-describedby="mensajeLiveFeedback"
                                        :state="mensajeState('mensaje')"
                                ></b-form-textarea>
                                <b-form-invalid-feedback id="mensajeLiveFeedback">
                                    Este Campo es requerido debe escribir al menos 3 caracteres.
                                </b-form-invalid-feedback>
                            </b-form-group>
                            <b-row>
                                <b-col style="text-align: center">
                                    <button class="button-primary-support" id="enviar-support" type="submit" :disabled="$v.form.$invalid">
                                        <span class="button-text-support">ENVIAR</span>
                                    </button>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <ModalSend :content="contentMsj" v-if="activeModal"/>
    </b-container>
</template>
<script>
    import ModalSend from '@/components/Global/ModalSend'
    import {mapState} from 'vuex'
    import { validationMixin } from "vuelidate";
    import { required, minLength } from "vuelidate/lib/validators";


    export default {
        name: 'Support',
        mixins: [validationMixin],
        components: {ModalSend},
        data: () => ({
            form: {
                mensaje: ''
            },
            show: true,
            contentMsj: '',
            contentSuccess: {
                title: 'Muchas Gracias',
                msj: 'Mensaje enviado <br> exitosomente',
                button: 'Aceptar',
                icon: 1
            },
            contentError: {
                title: 'Disculpe',
                msj: 'Intente mas tarde <br> Tenemos problemas con la plataforma',
                button: 'Aceptar',
                icon: 2
            }
        }),
        validations: {
            form: {
                mensaje: {
                    required,
                    minLength: minLength(3)
                }
            }
        },
        created() {
            this.$store.dispatch('setModulo', 'Soporte')
            this.$store.dispatch('setNav', 'inactive')
        },
        computed: {
            ...mapState(['activeModal'])
        },
        methods: {
            goRouter(url) {
                this.$router.push(url)
            },
            srcImagen(img) {
                let src = require('@/assets/images/' + img)
                return src
            },
            onSubmit(evt) {
                evt.preventDefault()
//                alert(JSON.stringify(this.form))
                this.$store.dispatch('postSupport', this.form)
                    .then((response) => {
                        console.log('response de postSupport:', response)
                        this.contentMsj = this.contentSuccess
                        this.onReset()
                        this.$store.dispatch('setActiveModal', true)
                    })
                    .catch((error) => {
                        this.contentMsj = this.contentError
                        this.$store.dispatch('setActiveModal', true)
                        console.log('error postSupport', error)
                    })
            },
            onReset() {
                this.form = {
                    mensaje: ''
                }
                this.$nextTick(() => {
                    this.$v.$reset();
                });
            },
            mensajeState() {
                const { $dirty, $error } = this.$v.form.mensaje;
                return $dirty ? !$error : null;
            }
        }
    }
</script>